<template>
  <v-speed-dial id="bottom_button" class="app-vue-speeddial"
      v-model="fab"
      :top="top"
      :bottom="bottom"
      :right="right"
      :left="left"
      :direction="direction"
      :hover="hover"
      :transition="transition"
      fixed
    >
      <v-btn class="ma-1"
        slot="activator"
        color="red darken-2"
        dark
        fab
        hover
        v-model="fab"
        to='/artefacts/new'
      >
        <v-icon>add</v-icon>
        
      </v-btn>

    </v-speed-dial>
</template>



<script>
  export default {
    data () {
      return {
          dialog: false,
          direction: "top",
      fab: false,
      fling: false,
      hover: false,
      tabs: null,
      top: false,
      right: true,
      bottom: true,
      left: false,
      transition: "slide-y-reverse-transition",
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Partials/BottomRedAddButton.vue